// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3wGyO","savePackageButton":"ClientWallet_savePackageButton__1teX-"};